import React from 'react';
import { SUPER_CHAT } from "../constants/gameConstant"

function CommentBox(name, comment, money, icon) {

    const setBoxColor = () => {
        if (money >= SUPER_CHAT.PRICE_LEVEL_7) {
            return "red";
        }
        else if (money >= SUPER_CHAT.PRICE_LEVEL_5) {
            return "orange";
        }
        else if (money >= SUPER_CHAT.PRICE_LEVEL_3) {
            return "yellow";
        }
        else if (money >= SUPER_CHAT.PRICE_LEVEL_2) {
            return "cyan"
        }
        else {
            return "white";
        }
    }

    const setIconColor = (name) => {
        let hash = 0;
        for (let i = 0; i < name.length; i++) {
            hash = name.charCodeAt(i) + ((hash << 5) - hash);
        }
        const color = `#${((hash >> 0) & 0xFFFFFF).toString(16).padStart(6, '0')}`;
        return color;
    }

    const showMoney = () => {
        if (money && money > 0) {
            return "¥" + money;
        }
        return "";
    }

    return (
        <div style={{
            width: "90%",
            border: "2px solid black",
            padding: "10px",
            margin: "5px",
            backgroundColor: setBoxColor(),
            position: "relative",
            fontFamily: "Arial, sans-serif"
        }}>
            <div className="commentBox-header">
                {/* アイコン画像を動的に設定 */}
                <img
                    src={icon ? `./img/${icon}` : "./img/icon.png"} // 指定があれば使用、なければデフォルト
                    alt="icon"
                    className="icon"
                    style={{
                        backgroundColor: icon ? "transparent" : setIconColor(name),
                        width: "50px",
                        height: "50px",
                        borderRadius: "50%",
                        marginRight: "10px",
                    }}
                />
                <span className="name">{name}</span>
                <span className="price">{showMoney()}</span>
            </div>
            <div className="commentBox-area">
                {comment}
            </div>
        </div >
    );
}

export default CommentBox;